import { createIcon } from '../createIcon';

export const OpenDrawerRightIconConfig = {
  name: 'OpenDrawerRightIcon',
  height: 1024,
  width: 1216,
  svgPath: 'M1184,0 C1201.673,0 1216,14.334 1216,32.015 L1216,991.984 C1216,1009.666 1201.673,1024 1184,1024 L32,1024 C14.327,1024 0,1009.666 0,991.984 L0,32.015 C0,14.334 14.327,0 32,0 L1184,0 Z M1151.96,64.031 L64,64.031 L64,959.968 L1152,959.968 L1151.96,64.031 Z M1056.9407,128.6256 C1074.6467,128.6256 1088.9997,142.9716 1088.9997,160.6676 L1088.9997,863.9576 C1088.9997,881.6546 1074.6467,895.9996 1056.9407,895.9996 L737.0597,895.9996 C719.3537,895.9996 704.9997,881.6546 704.9997,863.9576 L704.9997,160.6676 C704.9997,142.9716 719.3537,128.6256 737.0597,128.6256 Z',
  yOffset: 0,
  xOffset: 0,
};

export const OpenDrawerRightIcon = createIcon(OpenDrawerRightIconConfig);

export default OpenDrawerRightIcon;